import { render, staticRenderFns } from "./FormProcessDesign.vue?vue&type=template&id=021a53ec&scoped=true"
import script from "./FormProcessDesign.vue?vue&type=script&lang=js"
export * from "./FormProcessDesign.vue?vue&type=script&lang=js"
import style0 from "./FormProcessDesign.vue?vue&type=style&index=0&id=021a53ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a53ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021a53ec')) {
      api.createRecord('021a53ec', component.options)
    } else {
      api.reload('021a53ec', component.options)
    }
    module.hot.accept("./FormProcessDesign.vue?vue&type=template&id=021a53ec&scoped=true", function () {
      api.rerender('021a53ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/components/FormProcessDesign.vue"
export default component.exports